import type { SVGProps } from 'react';
const SvgGamepad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#gamepad_svg__a)">
      <path
        fill="currentColor"
        d="M15 7.5V2H9v5.5l3 3 3-3ZM7.5 9H2v6h5.5l3-3-3-3ZM9 16.5V22h6v-5.5l-3-3-3 3ZM16.5 9l-3 3 3 3H22V9h-5.5Z"
      />
    </g>
    <defs>
      <clipPath id="gamepad_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGamepad;
